// RAG triage badge — Red (emergency) / Amber (moderate) / Green (routine).
// Single source of truth for triage colours across doctor + patient views.
// Renders nothing when there is no triage grade on the booking.

const RAG = {
  red: { label: 'Emergency', cls: 'bg-red-100 text-red-800 border-red-200', dot: 'bg-red-500' },
  amber: { label: 'Moderate', cls: 'bg-amber-100 text-amber-800 border-amber-200', dot: 'bg-amber-500' },
  green: { label: 'Routine', cls: 'bg-emerald-100 text-emerald-800 border-emerald-200', dot: 'bg-emerald-500' },
}

export function ragOf(severity) {
  return RAG[severity] || null
}

export default function TriageBadge({ severity, className = '' }) {
  const rag = ragOf(severity)
  if (!rag) return null
  return (
    <span
      title={`AI triage: ${rag.label}`}
      className={`inline-flex items-center gap-1 text-[10px] font-semibold uppercase tracking-wide border rounded-full px-2 py-0.5 ${rag.cls} ${className}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${rag.dot}`} />
      {rag.label}
    </span>
  )
}
